import { get } from '@eika-infrastruktur/request';
import type { SessionModel } from '@generated-types';
import { getApiUrl } from '../utils';

export const getSession = async (): Promise<SessionModel> => get(getApiUrl('session'));
